import React from 'react';

import LinkText from 'components/LinkText';

import './styles.css';

interface DepartureRoomCheckProps {
  id: number;
  roomNumber: string;
  roomType: string;
  invoiceReceivedAtFrontDesk: any;
}

interface DepartureRoomCheckBasicInformationProps {
  departureRoomCheck: DepartureRoomCheckProps;
  openInvoiceDetailModal: () => any;
}

class DepartureRoomCheckBasicInformation extends React.Component<
  DepartureRoomCheckBasicInformationProps
> {
  render() {
    const {
      departureRoomCheck: {roomNumber, roomType, invoiceReceivedAtFrontDesk},
      openInvoiceDetailModal
    } = this.props;

    return (
      <div className="DepartureRoomCheckBasicInformation colab-centered-v colab-sidepadding-2">
        <div>
          <div className="DepartureRoomCheckBasicInformation--label colab-bold">
            Room
          </div>
          <div className="DepartureRoomCheckBasicInformation--value">
            {roomNumber}
          </div>
        </div>
        <div>
          <div className="DepartureRoomCheckBasicInformation--label colab-bold">
            Room type
          </div>
          <div className="DepartureRoomCheckBasicInformation--value">
            {roomType}
          </div>
        </div>
        <div>
          <div className="DepartureRoomCheckBasicInformation--label colab-bold">
            Charge payment received at front desk
          </div>
          <div className="DepartureRoomCheckBasicInformation--value">
            {invoiceReceivedAtFrontDesk && (
              <LinkText onClick={openInvoiceDetailModal}>
                {invoiceReceivedAtFrontDesk.amountReceivedAtFrontDesk}
              </LinkText>
            )}
            {!invoiceReceivedAtFrontDesk && 'N/A'}
          </div>
        </div>
      </div>
    );
  }
}

export default DepartureRoomCheckBasicInformation;
